(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bird-collection-row"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bird-collection-slider')) {
    customElements.define('bird-collection-slider', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.events) return;
          this.track = this.querySelector('.bird-collection-row__list');
          this.previous = this.querySelector('.bird-collection-row__nav--previous');
          this.next = this.querySelector('.bird-collection-row__nav--next');
          if (!this.track || !this.previous || !this.next) return;
          this.events = new AbortController();
          const options = { signal: this.events.signal };
          this.previous.addEventListener('click', () => this.move(-1), options);
          this.next.addEventListener('click', () => this.move(1), options);
          this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.track);
          const media = this.querySelector('.bird-collection-row__media');
          if (media) this.observer.observe(media);
          this.update();
        });
      }

      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = null;
      }

      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.toggleAttribute('data-overflow', maximum > 2);
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
        const media = this.querySelector('.bird-collection-row__media');
        if (media) this.style.setProperty('--bird-slider-control-top', `${media.offsetHeight / 2}px`);
      }

      move(direction) {
        const card = this.track.querySelector('.bird-collection-row__item');
        if (!card) return;
        const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        this.track.scrollBy({
          left: direction * step,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bird-lifestyle-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bird-lifestyle-gallery')) {
    customElements.define('bird-lifestyle-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.track = this.querySelector('.bird-lifestyle-gallery__track');
        if (!this.track) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.previous = this.querySelector('[data-gallery-direction="-1"]');
        this.next = this.querySelector('[data-gallery-direction="1"]');
        this.position = this.querySelector('[data-gallery-position]');
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-gallery-direction]');
          if (button && !button.disabled) this.move(Number(button.dataset.galleryDirection));
        }, { signal });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        }, { passive: true, signal });
        this.resize?.disconnect();
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * rtl * (this.track.clientWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        const cards = [...this.track.children];
        const rect = this.track.getBoundingClientRect();
        const visible = cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index }))
          .filter(({ rect: card }) => card.left >= rect.left - 2 && card.right <= rect.right + 2);
        const offset = Math.abs(this.track.scrollLeft);
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        this.previous.hidden = this.next.hidden = overflow < 2;
        this.previous.disabled = offset < 2;
        this.next.disabled = offset >= overflow - 2;
        if (visible.length) {
          const message = this.position.dataset.label.replace('[first]', visible[0].index + 1).replace('[last]', visible.at(-1).index + 1).replace('[total]', cards.length);
          if (this.position.textContent !== message) this.position.textContent = message;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
